import { render, staticRenderFns } from "./_fileBackupsCard.vue?vue&type=template&id=6873d706"
import script from "./_fileBackupsCard.vue?vue&type=script&lang=js"
export * from "./_fileBackupsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports